var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", {
    staticClass: "d-flex justify-center",
    style: `height:${_vm.heightComputed}px`,
    attrs: { id: _vm.rootElementId },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }